import { gql } from '@apollo/client';

const INSERT_AVAILABILITY_NOTIFICATION = gql`
  mutation INSERT_NOTIFICATION(
    $id: Int!
    $seats_remaining: Int!
    $slot: String
    $date: String
    $tour: String
    $total_seats: Int!
    $managerEmail: String
    $city: String
  ) {
    insert_boatnew_availability_shortage(
      objects: {
        id: $id
        seats_remaining: $seats_remaining
        slot_time: $slot
        date: $date
        tour: $tour
        total_seats: $total_seats
        managerEmail: $managerEmail
        city: $city
      }
    ) {
      returning {
        id
      }
    }
  }
`;
export const AVAILABILITY_NOTIFICATION_STATUS = gql`
  query AVAILABILITY_NOTIFICATION_STATUS($id: Int!) {
    boatnew_availability_shortage(where: { id: { _eq: $id } }) {
      id
    }
  }
`;

export const BOATNEW_PRODUCTS_WITH_CITIES = gql`
  query BOATNEW_PRODUCTS_WITH_CITIES {
    boatnew_products {
      cities_products {
        city {
          ops_manager {
            email
            first_name
          }
          name
        }
      }
    }
  }
`;

export default INSERT_AVAILABILITY_NOTIFICATION;
